<app-import-nav />

@if (!loading) {
  <div>
    @if (curatedSpecialtiesImports.length > 0) {
      <section class="mt-3">
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'imports'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>STATUS</th>
              <th class="text-nowrap text-end">IMPORTED AT &#x25BC;</th>
              <th class="text-end">PROCESSED</th>
              <th class="text-end">ADDED</th>
              <th class="text-end">REMOVED</th>
              <th class="text-end">FAILURE MESSAGE</th>
            </tr>
          </thead>
          <tbody>
            @for (curatedSpecialtiesImport of curatedSpecialtiesImports; track curatedSpecialtiesImport) {
              <tr>
                <td>{{ curatedSpecialtiesImport.status | titlecase }}</td>
                <td class="text-end">
                  {{ curatedSpecialtiesImport.createdAt | date: 'M/d/yyyy h:mm a' }}
                  <div>
                    <small>{{ curatedSpecialtiesImport.username }}</small>
                  </div>
                </td>
                <td class="text-end">{{ curatedSpecialtiesImport.processed | number: '' }}</td>
                <td class="text-end">{{ curatedSpecialtiesImport.added | number: '' }}</td>
                <td class="text-end">{{ curatedSpecialtiesImport.removed | number: '' }}</td>
                <td class="text-end">{{ curatedSpecialtiesImport.failureMessage }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section class="mt-3"><p>There are no imports.</p></section>
    }
  </div>
} @else {
  <section class="mt-3"><mat-spinner diameter="30" /></section>
}
